// FIXME: Actually make this lazy load. The `require([])` is currently being evaluated as a static import.
// Initialize favorites button (in header, above the fold)
import '@/favorites/lazyloader'
import { registerHandlerElementSideNav } from '@/utils/queues/handlers/element/side-nav'
import { initializeCartTransitionUtils } from '@/utils/cartTransitionUtils'
import { initTier2Common } from '../common/tier2'

export const initTier2NotCheckout = async (): Promise<void> => {
  // TODO: Avoid side effecting imports and call their initialization methods here for better control over loading
  registerHandlerElementSideNav()
  initializeCartTransitionUtils()
  await Promise.all([initTier2Common()])
}
